import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimaryOne = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimaryOne.palette['--sui-palette-background-primary'] = '246 243 239';

export { WinterHoliday2026PrimaryOne };